import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
@Component({
    selector: 'app-edit-button-renderer',
    template: `
    <div class="action-button-container">
      <button *ngIf="fileUrl" class="invoice-btn" (click)="onViewInvoice()">
        Invoice
      </button>
      <span *ngIf="!fileUrl">No Invoice</span>
    </div>
  `,
    styleUrls: ['./maintenance.component.scss']
})

export class InvoiceButtonRendererMaintenanceComponent implements ICellRendererAngularComp {
    constructor(private router: Router) { }
    params: any;
    fileUrl!: string;
    agInit(params: any): void {
        this.params = params;
        this.fileUrl = this.params.data.fileName || null;
    }

    refresh(params?: any): boolean {
        this.fileUrl = params.data.fileName;
        return true;
    }

    onViewInvoice() {
        if (this.params.onViewInvoice instanceof Function) {
            this.params.onViewInvoice(this.params.data.fileName);
        }
    }
}